import { useIsThrottleActive } from "../../hooks/useIsThrottleActive";

/**
 * Whether the Apollo-migrated MarketCard is switched on for **exchange** markets, on top of
 * `MARKET_CARD_APOLLO`. The card is far more heavily used on exchange, so that side of the business
 * validates it on its own schedule; gating the two products separately lets sportsbook roll out first
 * instead of waiting on that.
 *
 * Absent means off, so exchange keeps rendering the legacy card in any environment where the throttle
 * has not been configured — including the web test fixture, whose `{{else}}` branch defaults it false
 * (unlike `MARKET_CARD_APOLLO`, which defaults true there). CI therefore drives the LEGACY exchange
 * path, matching production, and the migrated exchange path has unit coverage only: the each-way PNL
 * rows, terms row and cashout are exercised by the package's own tests and by `PebbleContent`'s, not by
 * any e2e run. Flip the fixture default to cover it end to end, and expect `exc-each-way-market` to need
 * repointing onto the migrated selectors again if you do.
 */
export const useMarketCardExchangeApolloThrottle = (): boolean => useIsThrottleActive("MARKET_CARD_APOLLO_EXCHANGE");
